
const httpService  = (requestConfig) => {
    if (requestConfig.params) {
        // Map standard `params` to non-standard jQuery `data`
        requestConfig.data = Object.assign({}, requestConfig.data, requestConfig.params);
    }

    const request = $.ajax(requestConfig);

    return new Promise((resolve, reject) => {
        request.then(resolve, (jqXHR, textStatus, e) => {
            reject(jqXHR.responseJSON || e);
        });
    });
};
export default httpService;